export default "__VITE_ASSET__f84193bb__"